// extracted by mini-css-extract-plugin
export default {"SuccessManagerOptionsIcon":"styles_SuccessManagerOptionsIcon__q3Wwq","controlButton":"styles_controlButton__bLG1h","icon":"styles_icon__Xn0ZF"};